import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  frameIdsTextBox: {
    minWidth: '100%',
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
